export enum FollowUpTab {
  Leads = 0,
  LeadsHistory = 1,
  Projects = 2,
  ProjectsHistory = 3
}
